import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import LeadsOptions from "./options";
import {getAllLeadsListing,updateLeadStatus} from "../../../service/LeadManagement/action";
const mapStateToProps = (state) => ({
    allLeads:state.LeadManagement.allLeads,
    updatedLead:state.LeadManagement.updatedLead,
    // leadFilters:state.LeadManagement.leadFilters,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAllLeadsListing,
            updateLeadStatus,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadsOptions);
